module.exports = __webpack_public_path__ + "img/profil_lapper_Rudy.2c642585.png";